import ClientDocumentPage from '../../../shared/components/ClientDocumentPage.jsx'

const API_BASE = import.meta.env.VITE_FINANCE_API_URL || '/api/finance'

/**
 * The client's copy of a finalised invoice, opened from the link we email them.
 *
 * Replaces an attached PDF, for the same reason as the proposal page — and this was the stronger
 * case: branded mail, an attached PDF, a real dollar figure, and nothing verifiable on it.
 */
export default function ClientInvoice() {
  const money = (v) =>
    typeof v === 'number'
      ? v.toLocaleString(undefined, { style: 'currency', currency: 'USD' })
      : null

  return (
    <ClientDocumentPage
      // NOT `${API_BASE}/api/v1`. nginx rewrites /api/finance/(.*) -> /api/v1/$1 on the way in, so
      // spelling /api/v1 here again produces /api/v1/api/v1/... and a generic 404.
      apiBase={API_BASE}
      path="client/invoice"
      heading="Invoice"
      fallbackName="invoice.pdf"
      gone="This link is no longer valid. Please ask for a new one."
      renderMeta={(d) => {
        if (!d) return null
        const parts = [d.invoice_ref, d.project_name, money(d.total)].filter(Boolean)
        return parts.join(' · ')
      }}
    />
  )
}
